(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["quantity-breaks"] && !Shopify.designMode) return;
  try {
    function syncMeowfitsStickyOffers() {
  document.querySelectorAll('quantity-breaks').forEach((offers) => {
    const sync = () => {
      const selected = offers.querySelector('input[type="radio"]:checked');
      if (!selected) return;

      const offer = offers.querySelector('label[for="' + selected.id + '"]');
      const price = offer?.querySelector('.quantity-break__price');
      const label = offer?.querySelector('.quantity-break__label-text');
      const sticky = document.getElementById(
        'sticky-atc-' + offers.dataset.section
      );
      if (!price || !sticky) return;

      const total = document.createElement('span');
      if (label) {
        total.append(
          document.createTextNode(label.textContent.trim() + ' · ')
        );
      }

      const amount = document.createElement('strong');
      amount.textContent = price.textContent.trim();
      total.append(amount);

      sticky.querySelectorAll(
        '.sticky-atc__price, .sticky-atc__button-price'
      ).forEach((target) => {
        if (target.textContent !== total.textContent) {
          target.replaceChildren(total.cloneNode(true));
        }
      });
    };

    offers.addEventListener('change', () => requestAnimationFrame(sync));
    new MutationObserver(sync).observe(offers, {
      childList: true,
      subtree: true,
      characterData: true
    });
    sync();
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', syncMeowfitsStickyOffers);
} else {
  syncMeowfitsStickyOffers();
}

document.addEventListener('shopify:section:load', syncMeowfitsStickyOffers);
  } catch(e) { console.error(e); }
})();

})();
